// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39d48b0d","952":"035e9e34"}[chunkId] + ".chunk.js";
};